import { Button } from '@vfde-brix/ws10/button';
import { FormElement } from '@vfde-brix/ws10/form-element';
import {
    InputFieldType,
    AdditionalParams,
    ValidationFormFieldType,
    onlyNumbers,
    formValidation,
} from '@vfde-brix/ws10/validation';

/**
 * Helper function to simplify and make mountUI abstract
 */
export const validateForm = (formFields: FormElement[], submitButton: Button): void => {
    const form = {
        formFields,
        submitButton,
    };
    formValidation(form);
};

/**
 * Check that value matchđes any German mobile number format
 * NB: This check assumed you have used the mobile-number formatter to make sure it starts with a zero and all non digits removed
 */
export const mobileNumber = (inputFields: InputFieldType[]): boolean => {
    const value = inputFields[0].value.trim();

    /**
     * Check for the following formats:
     * - Optionally a + at the beginning, followed by 5 to 13 digits
     * - GSM followed by 5 to 13 digits
     * Examples:
     * +4915192345678
     * 15192345678
     * GSM15192345678
     * 004915192345678
     */
    return value === '' || /^\+?\d{5,13}$|^GSM\d{5,13}$|^0049\d{5,13}$/.test(value);
};

/**
 * Check that value matches the given length
 * we only need to add inputType as it's the second optional parameter and we need the third
 */
export const exactLength = (inputFields: InputFieldType[], inputType: ValidationFormFieldType, { length }: AdditionalParams): boolean => {
    const value = inputFields[0].value.trim();

    return value.length === length;
};

// validators
export const VALIDATOR_PHONE_NUMBER =
    {
        validator: mobileNumber,
        errorKey: 'mobileNumber',
    };
export const VALIDATOR_ONLY_NUMBERS =
    {
        validator: onlyNumbers,
        errorKey: 'onlyNumbers',
    };
export const EXACT_LENGTH_6 =
    {
        validator: exactLength,
        errorKey: 'exactLength',
        length: 6,
    };

/**
 * Adjust the phone number to fit the backend requirements
 */
export const normalizePhoneNumber = (phoneNumber: string): string => {
    // Replace 0049 with 0
    if (phoneNumber.startsWith('0049')) {
        return `0${ phoneNumber.substring(4)}`;
    }

    // Check if the phone number starts with "GSM" or "0"
    if (phoneNumber.startsWith('GSM') || phoneNumber.startsWith('0')) {
        return phoneNumber;
    }

    // Replace +49 with 0
    if (phoneNumber.startsWith('+49')) {
        return `0${ phoneNumber.substring(3)}`;
    }

    // Replace 49 with 0
    if (phoneNumber.startsWith('49')) {
        return `0${ phoneNumber.substring(2)}`;
    }

    // For any other case, prepend "GSM"
    return `GSM${ phoneNumber}`;
};
